import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import * as _ from 'lodash';
import financeApi from '@/api/finance';
var state = {
  incomes: [],
  incomesParams: {}
};
var mutations = {
  INCOMES: function INCOMES(state, incomes) {
    state.incomes = incomes;
  },
  INCOMES_PARAMS: function INCOMES_PARAMS(state, params) {
    state.incomesRequestParams = params;
  }
};
var actions = {
  loadIncomes: function () {
    var _loadIncomes = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, params) {
      var commit, res, status, message, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            commit('INCOMES_PARAMS', params);
            _context.next = 4;
            return financeApi.getAllIncomes(params);
          case 4:
            res = _context.sent;
            status = res.status, message = res.message, data = res.data;
            if (!(status === '0')) {
              _context.next = 11;
              break;
            }
            commit('INCOMES', data);
            return _context.abrupt("return", res);
          case 11:
            commit('INCOMES', []);
            return _context.abrupt("return", Promise.reject("请求失败，" + message));
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function loadIncomes(_x, _x2) {
      return _loadIncomes.apply(this, arguments);
    }
    return loadIncomes;
  }(),
  loadOutlays: function () {
    var _loadOutlays = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2, params) {
      var commit, resp, status, message, data, current, size, total, pages;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit;
            _context2.next = 3;
            return financeApi.getOutlays(params);
          case 3:
            resp = _context2.sent;
            status = resp.status, message = resp.message, data = resp.data, current = resp.current, size = resp.size, total = resp.total, pages = resp.pages;
            if (!(status === '0')) {
              _context2.next = 10;
              break;
            }
            commit('OUTLAYS', data);
            return _context2.abrupt("return", resp);
          case 10:
            commit('OUTLAYS', []);
            return _context2.abrupt("return", Promise.reject("请求失败，" + message));
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function loadOutlays(_x3, _x4) {
      return _loadOutlays.apply(this, arguments);
    }
    return loadOutlays;
  }()
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};